module.exports = __webpack_public_path__ + "img/01-15GF整合数据分析系统.8ab66d44.png";